enum AILanguage {
  fr = "fr",
  en = "en",
}

export const aiLanguageAsString = (aiLanguage: AILanguage): string => {
  switch (aiLanguage) {
    case AILanguage.fr:
      return "Français";
    case AILanguage.en:
      return "Anglais";
    default:
      return "";
  }
};

export default AILanguage;
